import useMediaQuery from "@mui/material/useMediaQuery";
import blackBackground from "@images/backgrounds/black.jpg";
import logoWhite from "@images/logos/logoWhite.png";
import "./TitleScreen.scss";
import { useEffect, useState } from "react";
import AWSService from "@services/AWSService";

const getBackgroundVideo = async (): Promise<string | undefined> => {
  const response = await AWSService.getBackgroundVideos();
  const videos = response?.data;

  if (videos?.length) {
    const randomIndex = Math.floor(Math.random() * videos.length);
    return videos[randomIndex];
  }

  return undefined;
};

const TitleScreen = () => {
  const [loading, setLoading] = useState(true);
  const [backgroundVideo, setBackgroundVideo] = useState("");
  // Matches the app's $md-min breakpoint (screen-variables.scss) instead of user-agent sniffing,
  // so the background video is skipped on small viewports and responds correctly to resize.
  const isDesktopViewport = useMediaQuery("(min-width: 992px)");

  useEffect(() => {
    const fetchVideo = async () => {
      const video = await getBackgroundVideo();
      setBackgroundVideo(video || "");
      setLoading(false);
    };

    fetchVideo();
  }, []);

  return (
    <section className="title-screen section section-header bg-black">
      <div className="parallax">
        {!loading && isDesktopViewport && (
          <video poster={blackBackground} autoPlay={true} loop muted>
            <source src={backgroundVideo} type="video/mp4" />
          </video>
        )}
        <div className="container-fluid">
          <div className="content">
            <div className="title-area">
              <img src={logoWhite} className="title-screen-logo" alt="logo" />
            </div>
            <span className="title-arrow">
              <i className="far fa-arrow-alt-circle-down fa-5x animated bounce"></i>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TitleScreen;
